export default __webpack_public_path__ + "static/media/ava.2f4967a4.webp";